"use client";

import { Button } from "@relume_io/relume-ui";
import { RxChevronRight } from "react-icons/rx";
import { Link } from "react-router-dom";
export function Layout239() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="flex flex-col items-center">
          <div className="rb-12 mb-12 text-center md:mb-18 lg:mb-20">
            <div className="w-full max-w-lg">
              <h2 className="mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
                Our Commitment to Animal Welfare
              </h2>
              <p className="md:text-md">
                We provide essential services to ensure the health and safety of
                animals in our community. Our dedicated team works tirelessly to
                rescue, feed, and care for those in need.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 items-start justify-center gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
            <div className="flex w-full flex-col items-center text-center">
              <div className="rb-6 mb-6 md:mb-8">
                <img
                  src="./media/feeding.jpeg"
                  alt="Relume placeholder image"
                />
              </div>
              <h3 className="mb-5 text-2xl font-bold md:mb-6 md:text-3xl md:leading-[1.3] lg:text-4xl">
                Comprehensive Veterinary Care for Every Animal
              </h3>
              <p>
                Our veterinary services ensure that every animal receives the
                medical attention they deserve.
              </p>
            </div>
            <div className="flex w-full flex-col items-center text-center">
              <div className="rb-6 mb-6 md:mb-8">
                <img
                  src="./media/veterinary.jpeg"
                  alt="Relume placeholder image"
                />
              </div>
              <h3 className="mb-5 text-2xl font-bold md:mb-6 md:text-3xl md:leading-[1.3] lg:text-4xl">
                Nourishing Lives Through Our Feeding Programs
              </h3>
              <p>
                We provide food and nourishment to animals in need, helping them
                thrive.
              </p>
            </div>
            <div className="flex w-full flex-col items-center text-center">
              <div className="rb-6 mb-6 md:mb-8">
                <img
                  src="./media/rescue.jpeg"
                  alt="Relume placeholder image"
                />
              </div>
              <h3 className="mb-5 text-2xl font-bold md:mb-6 md:text-3xl md:leading-[1.3] lg:text-4xl">
                Rescue Operations for Abandoned and Neglected Animals
              </h3>
              <p>
                Our rescue efforts focus on saving animals from dire situations
                and finding them loving homes.
              </p>
            </div>
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
            {/* <Button variant="secondary">Learn More</Button> */}
            <Link to="/volunteer">
            <Button  variant="link" size="link">
              Get Involved
            </Button>
            </Link>
            {<RxChevronRight />}
          </div>
        </div>
      </div>
    </section>
  );
}
